// Bundle Builder MOOUI - Layer Your Look Format
(function() {
  'use strict';

  console.log('Bundle Builder carregado!');

  // Verifica se o tamanho da variante corresponde ao tamanho selecionado.
  // Normaliza aliases para aceitar "SOLT KING" e "SOLTEIRO KING",
  // mantendo KING separado de SOLTEIRO KING.
  function canonicalSize(value) {
    if (!value) return '';
    const normalized = String(value)
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, ' ')
      .trim()
      .replace(/\s+/g, ' ');

    const aliases = {
      BERCO: 'BERCO',
      'MINI CAMA': 'MINI_CAMA',
      MINICAMA: 'MINI_CAMA',
      SOLTEIRO: 'SOLTEIRO',
      'SOLT KING': 'SOLTEIRO_KING',
      'SOLTEIRO KING': 'SOLTEIRO_KING',
      CASAL: 'CASAL',
      QUEEN: 'QUEEN',
      KING: 'KING'
    };

    return aliases[normalized] || normalized;
  }

  function matchesSize(variantSize, targetSize) {
    if (!variantSize || !targetSize) return false;
    const vs = canonicalSize(variantSize);
    const ts = canonicalSize(targetSize);
    return vs === ts;
  }

  function isBedSizeAllowed(size) {
    const builder = document.querySelector('[data-bed-builder-sizes]');
    const configuredSizes = builder?.getAttribute('data-bed-builder-sizes');
    const allowedSizes = configuredSizes
      ? configuredSizes.split(',').map(value => value.trim())
      : Object.keys(window.BUNDLE_CONFIG?.sizeMapping || {});
    return allowedSizes.includes(size);
  }

  function cdnFile(url) {
    const v = window.BUNDLE_CONFIG?.cacheVersion || '1';
    return `${url}?v=${v}`;
  }

  // Estado do bundle
  const bundleState = {
    bedSize: null,
    pillowQuantity: 0,
    selectedProducts: {},
    currentCategory: 'pillowcase',
    pillowcaseType: null  // 'fronha-30x40' | 'fronha-50x70' — só relevante para Berço
  };

  // Descontos removidos temporariamente

  // Mapeamento de categorias para tags e collections
  const CATEGORY_CONFIG = {
    fitted_sheet: {
      tag: 'lencol-de-elastico',
      collection: 'lencois-de-elastico',
      needsSize: true
    },
    top_sheet: {
      tag: 'lencol-de-cima',
      collection: 'lencois-de-cima',
      needsSize: true
    },
    pillowcase: {
      collection: 'fronhas',
      needsSize: false
    },
    duvet_cover: {
      tag: 'capa-de-edredom',
      collection: 'capas-de-edredom',
      needsSize: true
    },
    duvet: {
      tag: 'edredom',
      collection: 'capas-de-edredom',
      needsSize: true,
      isCheckbox: true
    },
    colcha: {
      tag: 'colcha',
      collection: 'colchas',
      needsSize: true,
      productTypeBySize: {
        berco: 'Colcha Bebê',
        default: 'Jogo de Colcha'
      }
    },
    minhocao: {
      tag: 'minhocao',
      collection: 'protetores-de-berco',
      needsSize: false,
      productType: 'Minhocão',
      variantSize: 'U'
    }
  };

  // Regras de fronha por tamanho de cama
  // maxSlots: quantos slots de fronha existem
  // pillowTag: tag a buscar
  // unitQty: quantas unidades por slot (casal/queen/king = jogo de 2)
  const PILLOW_RULES = {
    berco:        { maxSlots: 1, tags: ['fronha-30x40'], unitQty: 1 },  // mista sobrescreve maxSlots para 2
    mini_cama:    { maxSlots: 2, tags: ['fronha-50x70'], unitQty: 1 },  // 1 fronha, pode adicionar 2ª
    solteiro:     { maxSlots: 2, tags: ['fronha-50x70'], unitQty: 1 },  // 1 fronha, pode adicionar 2ª
    solteiro_king:{ maxSlots: 2, tags: ['fronha-50x70'], unitQty: 1 },  // 2 fronhas individuais
    casal:        { maxSlots: 2, tags: ['fronha-50x70'], unitQty: 2 },  // jogo com 2 fronhas
    queen:        { maxSlots: 2, tags: ['fronha-50x70'], unitQty: 2 },  // jogo com 2 fronhas
    king:         { maxSlots: 2, tags: ['fronha-50x70'], unitQty: 2 }   // jogo com 2 fronhas
  };

  // Inicializa quando DOM estiver pronto
  function init() {
    setupEventListeners();
    setupStickyPreview();

    // Re-renderiza fronhas ao redimensionar para manter proporção
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (bundleState.selectedProducts['pillowcase'] && bundleState.selectedProducts['pillowcase'].length > 0) {
          updatePillowcasesPreview();
        }
      }, 150);
    }, { passive: true });
  }

  // Sticky via JS — desktop: 3 estados (topo/fixo/fundo); mobile: fixo no topo com spacer
  function setupStickyPreview() {
    const preview = document.querySelector('.bed-preview-container');
    const section = document.querySelector('.bundle-builder-products-section');
    const selection = document.querySelector('.selection-container');
    const bundleTitle = document.querySelector('.bundle-title');
    if (!preview || !section) return;

    function isMobileLayout() { return window.innerWidth <= 1024; }

    let mobileFixedAt = null;

    function fixTitle(previewHeight) {
      if (!bundleTitle) return;
      bundleTitle.classList.add('is-mobile-fixed-title');
      bundleTitle.style.top = previewHeight + 'px';
    }

    function unfixTitle() {
      if (!bundleTitle) return;
      bundleTitle.classList.remove('is-mobile-fixed-title');
      bundleTitle.style.top = '';
    }

    function update() {
      if (isMobileLayout()) {
        const previewHeight = preview.offsetHeight;
        const sectionBottom = section.getBoundingClientRect().bottom;
        const pastEnd = sectionBottom < previewHeight;

        if (!preview.classList.contains('is-mobile-fixed')) {
          // Fixa exatamente quando o topo do preview atinge o topo da viewport
          if (!pastEnd && preview.getBoundingClientRect().top <= 0) {
            mobileFixedAt = window.scrollY;
            const titleHeight = bundleTitle ? bundleTitle.offsetHeight : 0;
            if (selection) selection.style.paddingTop = (previewHeight + titleHeight) + 'px';
            preview.classList.add('is-mobile-fixed');
            fixTitle(previewHeight);
          }
        } else {
          // Desfixa quando rola de volta acima do ponto onde fixou
          if (window.scrollY < mobileFixedAt || pastEnd) {
            mobileFixedAt = null;
            preview.classList.remove('is-mobile-fixed');
            unfixTitle();
            if (selection) selection.style.paddingTop = '';
          }
        }
        return;
      }

      // Desktop: 3 estados
      const rect = section.getBoundingClientRect();
      const inZone  = rect.top <= 0 && rect.bottom >= window.innerHeight;
      const pastEnd = rect.bottom < window.innerHeight;

      preview.classList.toggle('is-fixed',  inZone);
      preview.classList.toggle('is-bottom', !inZone && pastEnd);
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  // Configura event listeners
  function setupEventListeners() {
    // Seleção de tamanho de cama
    document.querySelectorAll('.size-btn').forEach(btn => {
      btn.addEventListener('click', handleBedSizeSelect);
    });

    // Seleção de categoria
    document.querySelectorAll('.category-btn').forEach(btn => {
      btn.addEventListener('click', handleCategorySelect);
    });

    // Botão adicionar ao carrinho
    const addBtn = document.getElementById('addBundleBtn');
    if (addBtn) {
      addBtn.addEventListener('click', handleAddToCart);
    }

    // Botão recomeçar
    const startOverBtn = document.getElementById('btnStartOver');
    if (startOverBtn) {
      startOverBtn.addEventListener('click', handleStartOver);
    }

    // Botão próximo passo
    const skipBtn = document.getElementById('btnSkipStep');
    if (skipBtn) {
      skipBtn.addEventListener('click', handleSkipStep);
    }

    // Acordeom
    document.querySelectorAll('.accordion-header').forEach(btn => {
      btn.addEventListener('click', handleAccordionToggle);
    });
  }

  // Manipula toggle do acordeom
  function handleAccordionToggle(e) {
    const header = e.currentTarget;
    const accordionId = header.dataset.accordion;
    const content = document.getElementById(`accordion-${accordionId}`);

    // Toggle classes
    header.classList.toggle('active');
    content.classList.toggle('active');
  }

  // Manipula seleção de tamanho de cama
  function handleBedSizeSelect(e) {
    const btn = e.currentTarget;
    const size = btn.dataset.size;
    if (!isBedSizeAllowed(size)) return;

    // Atualiza estado
    bundleState.bedSize = size;
    bundleState.selectedProducts = {};
    bundleState.pillowcaseType = null; // Reseta tipo de fronha ao trocar tamanho

    // Marca botão como ativo
    document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Inicializa o preview da cama
    initializeBedPreview();

    // Atualiza tabela de medidas
    renderMeasurementsTable(size);

    // Esconde seletor de fronhas (não é mais usado como etapa)
    const pillowSelector = document.getElementById('pillowQuantitySelector');
    if (pillowSelector) pillowSelector.style.display = 'none';

    // Restaura visibilidade de todas as abas (remove ocultações por "sem produtos")
    document.querySelectorAll('.category-btn').forEach(b => b.style.display = '');

    // Minhocão: só aparece no Berço
    const minhocaoBtn = document.getElementById('btn-minhocao');
    if (minhocaoBtn) {
      minhocaoBtn.style.display = size === 'berco' ? '' : 'none';
    }

    // Lençol de cima: NÃO aparece em solteiro_king, casal, queen, king
    const topSheetBtn = document.querySelector('[data-category="top_sheet"]');
    const largerBeds = ['solteiro_king', 'casal', 'queen', 'king'];
    if (topSheetBtn) {
      topSheetBtn.style.display = largerBeds.includes(size) ? 'none' : '';
    }

    // Atualiza contadores e summary
    updateCategoryCounts();
    updateSummary();
    updateBedPreview();

    const categoryTabs = document.getElementById('categoryTabs');
    const productsArea = document.getElementById('productsArea');

    if (window.innerWidth <= 1024) {
      // Mobile: nenhum acordeão aberto ao escolher tamanho
      if (categoryTabs) categoryTabs.style.display = '';
      if (productsArea) productsArea.style.display = 'none';
    } else {
      // Desktop: restaura categoryTabs e ativa primeira categoria normalmente
      if (categoryTabs) categoryTabs.style.display = '';
      const firstCategoryBtn = document.querySelector('.category-btn:not([style*="display: none"])');
      if (firstCategoryBtn) {
        document.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));
        firstCategoryBtn.classList.add('active');
        bundleState.currentCategory = firstCategoryBtn.dataset.category;
        loadCategoryProducts(firstCategoryBtn.dataset.category);
      }
      const skipBtn = document.getElementById('btnSkipStep');
      if (skipBtn) skipBtn.classList.add('visible');
      if (productsArea) productsArea.style.display = '';
    }

    // Colapsa o seletor de tamanho e mostra o chip com o nome selecionado
    collapseSizeSelector(size);

    // Oculta proativamente abas sem produtos para o tamanho selecionado
    prefetchEmptyCategories(size);
  }

  // Verifica em background quais categorias não têm produtos para o tamanho e oculta as abas
  function prefetchEmptyCategories(size) {
    const sizeMapping = window.BUNDLE_CONFIG.sizeMapping[size];
    if (!sizeMapping) return;
    const sizeMappingUpper = sizeMapping.toUpperCase().trim();

    Object.entries(CATEGORY_CONFIG).forEach(([category, config]) => {
      // Só verifica categorias que dependem de tamanho e não são tratadas separadamente
      if (!config.needsSize || config.isCheckbox || category === 'pillowcase' || category === 'minhocao') return;

      const btn = document.querySelector(`.category-btn[data-category="${category}"]`);
      if (!btn || btn.style.display === 'none') return;

      fetch(`/collections/${config.collection}/products.json?limit=250`)
        .then(r => r.json())
        .then(data => {
          let products = data.products;

          if (config.tag) {
            products = products.filter(p => {
              const tags = Array.isArray(p.tags) ? p.tags : p.tags.split(',').map(t => t.trim());
              return tags.some(t => t.toLowerCase() === config.tag.toLowerCase());
            });
          }

          if (config.productTypeBySize) {
            const productType = config.productTypeBySize[size] || config.productTypeBySize.default;
            products = products.filter(p => p.product_type === productType);
          }

          const hasProducts = products.some(product =>
            product.variants.some(v => {
              const variantSize = v.option1 ? v.option1.toUpperCase().trim() : '';
              return v.available && matchesSize(variantSize, sizeMappingUpper);
            })
          );

          if (!hasProducts) {
            btn.style.display = 'none';
            if (btn.classList.contains('active')) {
              btn.classList.remove('active');
              const nextVisible = document.querySelector('.category-btn:not([style*="display: none"])');
              if (nextVisible) nextVisible.click();
            }
          }
        })
        .catch(() => {}); // silencioso — se falhar, mantém aba visível
    });
  }

  // Colapsa o seletor de tamanho após escolha
  function collapseSizeSelector(size) {
    const selector = document.querySelector('.bed-size-selector');
    const container = document.getElementById('startOverContainer');
    const label = document.getElementById('sizeSelectedLabel');
    const layout = document.getElementById('bundleMainLayout');
    const sizeNames = window.BUNDLE_CONFIG.sizeMapping;
    if (selector) selector.style.display = 'none';
    if (label) label.textContent = sizeNames[size] || size.toUpperCase();
    if (container) container.style.display = 'flex';
    if (layout) layout.classList.add('products-visible');
  }

  // Expande o seletor de tamanho (ao recomeçar)
  function expandSizeSelector() {
    const selector = document.querySelector('.bed-size-selector');
    const container = document.getElementById('startOverContainer');
    const layout = document.getElementById('bundleMainLayout');
    if (selector) selector.style.display = '';
    if (container) container.style.display = 'none';
    if (layout) layout.classList.remove('products-visible');
  }

  // Tabela de medidas por tamanho de cama
  const MEASUREMENTS = {
    berco: [
      { item: 'Lençol de Elástico', measure: '70 × 130 × 17 cm' },
      { item: 'Lençol de Cima', measure: '100 × 140 cm' },
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Fronha Bebê', measure: '40 × 30 cm' },
      { item: 'Capa de Edredom', measure: '110 × 160 cm' },
      { item: 'Edredom', measure: '110 × 160 cm' },
      { item: 'Colcha Bebê', measure: '100 × 140 cm' },
      { item: 'Minhocão', measure: '17 × 260 cm' }
    ],
    mini_cama: [
      { item: 'Lençol de Elástico', measure: '78 × 160 × 25 cm' },
      { item: 'Lençol de Cima', measure: '124 × 195 cm' },
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Capa de Edredom', measure: '130 × 190 cm' },
      { item: 'Edredom', measure: '130 × 190 cm' },
      { item: 'Jogo de Colcha', measure: '125 × 180 cm' },
      { item: 'Porta Travesseiro', measure: '78 × 58 cm (1 un. inclusa no jogo)' }
    ],
    solteiro: [
      { item: 'Lençol de Elástico', measure: '88 × 188 × 25 cm' },
      { item: 'Lençol de Cima', measure: '140 × 225 cm' },
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Capa de Edredom', measure: '143 × 220 cm' },
      { item: 'Edredom', measure: '143 × 220 cm' },
      { item: 'Jogo de Colcha', measure: '145 × 220 cm' },
      { item: 'Porta Travesseiro', measure: '78 × 58 cm (1 un. inclusa no jogo)' }
    ],
    solteiro_king: [
      { item: 'Lençol de Elástico', measure: '100 × 200 × 30 cm' },
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Capa de Edredom', measure: '180 × 240 cm' },
      { item: 'Edredom', measure: '180 × 240 cm' }
    ],
    casal: [
      { item: 'Lençol de Elástico', measure: '138 × 188 × 30 cm' },
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Capa de Edredom', measure: '220 × 240 cm' },
      { item: 'Edredom', measure: '220 × 240 cm' }
    ],
    queen: [
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Capa de Edredom', measure: '250 × 240 cm' },
      { item: 'Edredom', measure: '250 × 240 cm' }
    ],
    king: [
      { item: 'Fronha Padrão', measure: '70 × 50 cm' },
      { item: 'Capa de Edredom', measure: '280 × 250 cm' },
      { item: 'Edredom', measure: '280 × 250 cm' }
    ]
  };

  function renderMeasurementsTable(bedSize) {
    const container = document.getElementById('measurementsTableContainer');
    if (!container) return;

    const data = MEASUREMENTS[bedSize];
    if (!data) {
      container.innerHTML = '<p class="measurements-placeholder">Selecione o tamanho da cama para ver as medidas.</p>';
      return;
    }

    const sizeLabel = window.BUNDLE_CONFIG?.sizeMapping?.[bedSize] || bedSize;
    const rows = data.map(row =>
      `<tr><td>${row.item}</td><td>${row.measure}</td></tr>`
    ).join('');

    container.innerHTML = `
      <table class="measurements-table">
        <thead>
          <tr><th>Peça</th><th>Medida — ${sizeLabel}</th></tr>
        </thead>
        <tbody>${rows}</tbody>
      </table>
    `;
  }

  // Inicializa o preview da cama
  function initializeBedPreview() {
    const placeholder = document.getElementById('previewPlaceholder');
    const illustration = document.getElementById('bedIllustration');

    if (placeholder) placeholder.style.display = 'none';
    if (illustration) {
      illustration.style.display = 'block';
      illustration.setAttribute('data-bed-size', bundleState.bedSize);
    }
  }

  // Mostra seletor de quantidade de fronhas
  function showPillowQuantitySelector(options) {
    const container = document.getElementById('pillowQuantityOptions');
    const selector = document.getElementById('pillowQuantitySelector');

    container.innerHTML = options.map(qty => `
      <button class="quantity-btn" data-quantity="${qty}">
        ${qty} fronha${qty > 1 ? 's' : ''}
      </button>
    `).join('');

    // Adiciona event listeners
    container.querySelectorAll('.quantity-btn').forEach(btn => {
      btn.addEventListener('click', handlePillowQuantitySelect);
    });

    selector.style.display = 'block';
  }

  // Manipula seleção de quantidade de fronhas
  function handlePillowQuantitySelect(e) {
    const btn = e.currentTarget;
    const quantity = parseInt(btn.dataset.quantity);

    bundleState.pillowQuantity = quantity;

    // Marca botão como ativo
    document.querySelectorAll('.quantity-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');

    // Layout principal já está visível, apenas carrega produtos
    loadCategoryProducts('pillowcase');
  }

  // Manipula seleção de categoria
  function handleCategorySelect(e) {
    const btn = e.currentTarget;
    const category = btn.dataset.category;
    const productsArea = document.getElementById('productsArea');

    if (window.innerWidth <= 1024 && productsArea) {
      // Mobile: acordeão — toggle se clicar na ativa, senão abre a nova
      const isAlreadyActive = btn.classList.contains('active');

      document.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));

      if (isAlreadyActive) {
        // Fecha: esconde o productsArea sem mover
        productsArea.style.display = 'none';
        return;
      }

      // Abre: move productsArea para após este botão
      btn.classList.add('active');
      btn.after(productsArea);
      productsArea.style.display = '';
      bundleState.currentCategory = category;
      loadCategoryProducts(category);
      return;
    }

    // Desktop: comportamento original
    document.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));
    btn.classList.add('active');
    bundleState.currentCategory = category;
    loadCategoryProducts(category);
  }

  function handleSkipStep() {
    const visibleBtns = Array.from(
      document.querySelectorAll('.category-btn:not([style*="display: none"])')
    );
    const activeIndex = visibleBtns.findIndex(b => b.classList.contains('active'));
    const nextBtn = visibleBtns[activeIndex + 1];

    if (nextBtn) {
      nextBtn.click();

      if (window.innerWidth <= 1024) {
        // Mobile: scroll para o botão do próximo item do acordeão
        setTimeout(() => {
          nextBtn.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 50);
      } else {
        // Desktop: scroll horizontal dentro do container de tabs
        const tabsContainer = document.getElementById('categoryTabs');
        if (tabsContainer) {
          const btnLeft = nextBtn.offsetLeft;
          const btnWidth = nextBtn.offsetWidth;
          const containerWidth = tabsContainer.offsetWidth;
          tabsContainer.scrollTo({
            left: btnLeft - (containerWidth / 2) + (btnWidth / 2),
            behavior: 'smooth'
          });
        }
      }
    }
  }

  // TESTE: Log completo de uma variante
  window.testVariantPrice = function() {
    fetch('/collections/fronhas/products.json?limit=1')
      .then(res => res.json())
      .then(data => {
        if (data.products && data.products[0]) {
          const product = data.products[0];
          const variant = product.variants[0];
          console.log('=== TESTE DE PREÇO ===');
          console.log('Produto:', product.title);
          console.log('variant.price (valor):', variant.price);
          console.log('variant.price (tipo):', typeof variant.price);
          console.log('parseFloat(variant.price):', parseFloat(variant.price));
          console.log('parseInt(variant.price):', parseInt(variant.price));
          console.log('Variant completo:', variant);
        }
      })
      .catch(err => console.error('Erro no teste:', err));
  };

  // Carrega produtos de uma categoria
  function loadCategoryProducts(category) {
    const config = CATEGORY_CONFIG[category];
    const container = document.getElementById('productGrid');

    if (!config) return;

    // Remove classe de modo pillow se existir
    container.classList.remove('pillow-container-mode');

    // Tratamento especial para fronhas - carrega direto baseado nas regras do tamanho
    if (category === 'pillowcase') {
      renderPillowcaseArea(container);
      return;
    }

    // Tratamento especial para edredom (checkbox)
    if (config.isCheckbox) {
      renderDuvetCheckbox(container);
      return;
    }

    container.innerHTML = '<p class="loading">Carregando produtos...</p>';

    // Busca produtos para outras categorias
    fetch(`/collections/${config.collection}/products.json?limit=250`)
      .then(response => response.json())
      .then(data => {
        let products = data.products.filter(p => {
          const tags = Array.isArray(p.tags) ? p.tags : (p.tags || '').split(',').map(t => t.trim());
          return !tags.some(t => t.toLowerCase() === 'block');
        });

        console.log(`Categoria ${category}: ${products.length} produtos encontrados na collection ${config.collection}`);

        if (config.tag) {
          products = products.filter(p => {
            if (!p.tags) return false;
            // Tags podem vir como string ou array
            const tagsArray = Array.isArray(p.tags) ? p.tags : p.tags.split(',').map(t => t.trim());
            const hasTag = tagsArray.some(t => t.toLowerCase() === config.tag.toLowerCase());
            if (category === 'minhocao') {
              console.log('Produto:', p.title, 'Tags:', tagsArray, 'Procurando:', config.tag, 'Match:', hasTag);
            }
            return hasTag;
          });
          console.log(`Após filtro por tag "${config.tag}": ${products.length} produtos`);
        }

        // Filtro fixo por tipo de produto (ex.: minhocão completo, sem capas avulsas)
        if (config.productType) {
          products = products.filter(p => p.product_type === config.productType);
        }

        // Filtra por product_type se configurado (ex: colcha berço vs jogo de colcha)
        let imageCategory = category;
        if (config.productTypeBySize) {
          const bedSize = bundleState.bedSize;
          const productType = config.productTypeBySize[bedSize] || config.productTypeBySize.default;
          products = products.filter(p => p.product_type === productType);
          imageCategory = bedSize === 'berco' ? `${category}_bebe` : category;
        }

        renderProducts(container, products, category, imageCategory);
      })
      .catch(error => {
        console.error('Erro ao carregar produtos:', error);
        container.innerHTML = '<p>Erro ao carregar produtos. Verifique o console.</p>';
      });
  }

  // Seletor de tipo de fronha (exclusivo para Berço)
  function renderPillowcaseTypePicker(container) {
    container.classList.add('pillow-container-mode');
    container.innerHTML = `
      <div class="pillow-type-picker">
        <p class="pillow-type-title">Qual tamanho de fronha?</p>
        <div class="pillow-type-options">
          <button class="pillow-type-btn" data-tag="fronha-30x40">
            <span class="pillow-type-size">30 × 40 cm</span>
            <span class="pillow-type-label">Fronha Bebê</span>
          </button>
          <button class="pillow-type-btn" data-tag="fronha-50x70">
            <span class="pillow-type-size">50 × 70 cm</span>
            <span class="pillow-type-label">Fronha Padrão</span>
          </button>
        </div>
      </div>
    `;

    container.querySelectorAll('.pillow-type-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        bundleState.pillowcaseType = btn.dataset.tag;
        renderPillowcaseArea(container);
      });
    });
  }

  // Renderiza a área de fronhas com slots e grid de produtos
  function renderPillowcaseArea(container) {
    const bedSize = bundleState.bedSize;

    // Para Berço: mostrar seletor de tipo antes do grid
    if (bedSize === 'berco' && !bundleState.pillowcaseType) {
      renderPillowcaseTypePicker(container);
      return;
    }

    // Usa a tag escolhida (Berço pode ter escolhido 30x40, 50x70 ou mista)
    let rules = PILLOW_RULES[bedSize];
    if (bedSize === 'berco' && bundleState.pillowcaseType === 'fronha-mista') {
      rules = { ...rules, maxSlots: 2, unitQty: 1, tags: [] };
    } else if (bedSize === 'berco' && bundleState.pillowcaseType) {
      rules = { ...rules, tags: [bundleState.pillowcaseType] };
    }

    // Adiciona classe especial ao container para ajustar layout
    container.classList.add('pillow-container-mode');

    if (!rules) {
      container.innerHTML = '<p>Selecione o tamanho da cama primeiro.</p>';
      return;
    }

    const selected = bundleState.selectedProducts['pillowcase'] || [];
    const unitLabel = rules.unitQty > 1 ? `Jogo de Fronhas (${rules.unitQty} un.)` : 'Fronha';

    // Estado: estamos escolhendo o slot qual? (0 = primeira fronha, 1 = segunda fronha)
    const currentSlot = bundleState.pillowcaseCurrentSlot !== undefined ? bundleState.pillowcaseCurrentSlot : 0;

    // Monta resumo dos slots selecionados (cards compactos no topo)
    let selectedSlotsHtml = '';
    selected.forEach((slotProduct, i) => {
      const thumbnailUrl = getColorThumbnail(slotProduct.color);
      selectedSlotsHtml += `
        <div class="pillow-slot pillow-slot--filled" data-slot="${i}">
          <div class="pillow-slot-img">
            <img src="${thumbnailUrl}" alt="${slotProduct.color}"
                 onerror="this.src='https://via.placeholder.com/80'">
          </div>
          <div class="pillow-slot-info">
            <span class="pillow-slot-label">${unitLabel} ${i + 1}</span>
            <span class="pillow-slot-color">${slotProduct.color}</span>
          </div>
          <button class="pillow-slot-remove" data-slot="${i}">✕</button>
        </div>
      `;
    });

    // Botão "+ Adicionar jogo 2" aparece só se:
    // - Já tem jogo 1 selecionado
    // - Ainda não tem jogo 2
    // - maxSlots >= 2
    const canAddSlot2 = selected.length === 1 && rules.maxSlots >= 2 && bundleState.pillowcaseType !== 'fronha-mista';

    let headerHtml = '';
    if (selected.length > 0) {
      // Label do botão considera unitQty
      const addButtonMainText = rules.unitQty > 1
        ? `Adicionar ${rules.unitQty} fronhas (jogo 2)`
        : 'Adicionar Fronha 2';

      const addButtonHtml = `
        <span class="btn-add-icon">+</span>
        <span class="btn-add-text">
          <span class="btn-add-main">${addButtonMainText}</span>
          <span class="btn-add-optional">(opcional)</span>
        </span>
      `;

      headerHtml = `
        <div class="pillow-slots-header">
          <div class="pillow-slots" id="pillowSlots">${selectedSlotsHtml}</div>
          ${canAddSlot2 ? `
            <button class="btn-add-pillow-slot" id="btnAddPillowSlot">
              ${addButtonHtml}
            </button>
          ` : ''}
        </div>
      `;
    }

    // Berço com 1 fronha escolhida (tipo único): oferecer adicionar o outro tamanho
    if (bedSize === 'berco' && selected.length === 1 && bundleState.pillowcaseType !== 'fronha-mista') {
      container.classList.add('pillow-container-mode');
      const slot0IsBebe = selected[0].fronhaPrefix === 'fronha-bebe';
      const otherSizeLabel = slot0IsBebe ? 'Fronha Padrão (50×70)' : 'Fronha Bebê (30×40)';
      const currentSizeLabel = slot0IsBebe ? 'Fronha Bebê (30×40)' : 'Fronha Padrão (50×70)';
      const thumbnailUrl = getColorThumbnail(selected[0].color);

      container.innerHTML = `
        <div class="pillow-slots-header">
          <div class="pillow-slots" id="pillowSlots">
            <div class="pillow-slot pillow-slot--filled" data-slot="0">
              <div class="pillow-slot-img">
                <img src="${thumbnailUrl}" alt="${selected[0].color}"
                     onerror="this.src='https://via.placeholder.com/80'">
              </div>
              <div class="pillow-slot-info">
                <span class="pillow-slot-label">${currentSizeLabel}</span>
                <span class="pillow-slot-color">${selected[0].color}</span>
              </div>
              <button class="pillow-slot-remove" data-slot="0">✕</button>
            </div>
            <button class="btn-add-pillow-slot" id="btnAddOtherSize">
              <span class="btn-add-icon">+</span>
              <span class="btn-add-text">
                <span class="btn-add-main">Adicionar ${otherSizeLabel}</span>
                <span class="btn-add-optional">(opcional)</span>
              </span>
            </button>
          </div>
        </div>
        <button class="pillow-type-back" id="btnPillowTypeBack">← Trocar tamanho de fronha</button>
      `;

      container.querySelector('.pillow-slot-remove').addEventListener('click', (e) => {
        e.stopPropagation();
        removePillowSlot(0);
      });

      document.getElementById('btnAddOtherSize').addEventListener('click', () => {
        bundleState.pillowcaseType = 'fronha-mista';
        bundleState.pillowcaseCurrentSlot = 1;
        renderPillowcaseArea(container);
      });

      document.getElementById('btnPillowTypeBack').addEventListener('click', () => {
        bundleState.pillowcaseType = null;
        bundleState.selectedProducts['pillowcase'] = [];
        updateCategoryCounts();
        updateSummary();
        renderPillowcaseArea(container);
      });

      return;
    }

    // Se já tem maxSlots jogos (slots atingidos), mostra só os slots, sem grid
    if (selected.length >= rules.maxSlots) {
      const totalUnits = selected.length * rules.unitQty;
      container.innerHTML = `
        ${headerHtml}
        <p class="pillow-pick-hint" style="margin-top:16px;">Todas as ${totalUnits} fronhas selecionadas.</p>
      `;

      // Event listeners de remoção
      container.querySelectorAll('.pillow-slot-remove').forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.stopPropagation();
          const slot = parseInt(btn.dataset.slot);
          removePillowSlot(slot);
        });
      });
      return;
    }

    // Mostra grid de produtos para o slot atual
    let slotLabel;
    if (bundleState.pillowcaseType === 'fronha-mista') {
      // Rótulo do outro tipo (oposto ao que está em slot 0)
      const slot0IsBebe = selected[0]?.fronhaPrefix === 'fronha-bebe';
      const otherLabel = slot0IsBebe ? 'Fronha Padrão (50×70)' : 'Fronha Bebê (30×40)';
      slotLabel = `Escolha a ${otherLabel} (opcional):`;
    } else if (selected.length === 0) {
      slotLabel = rules.unitQty > 1
        ? `Escolha o jogo de ${rules.unitQty} fronhas:`
        : 'Escolha a fronha 1:';
    } else {
      slotLabel = rules.unitQty > 1
        ? `Escolha o jogo 2 de ${rules.unitQty} fronhas (opcional):`
        : 'Escolha a fronha 2 (opcional):';
    }

    const typeBackLink = (bedSize === 'berco' && bundleState.pillowcaseType) ? `
      <button class="pillow-type-back" id="btnPillowTypeBack">
        ← Trocar tamanho de fronha
      </button>
    ` : '';

    container.innerHTML = `
      ${headerHtml}
      <div class="pillow-grid-label">
        ${typeBackLink}
        <p class="pillow-pick-hint">${slotLabel}</p>
      </div>
      <div id="pillowProductGrid" class="product-grid"></div>
    `;

    // Event listeners de remoção
    container.querySelectorAll('.pillow-slot-remove').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const slot = parseInt(btn.dataset.slot);
        removePillowSlot(slot);
      });
    });

    // Botão "Trocar tamanho de fronha" (Berço)
    const btnBack = document.getElementById('btnPillowTypeBack');
    if (btnBack) {
      btnBack.addEventListener('click', () => {
        bundleState.pillowcaseType = null;
        bundleState.selectedProducts['pillowcase'] = [];
        updateCategoryCounts();
        updateSummary();
        renderPillowcaseArea(container);
      });
    }

    // Event listener do botão "+ Adicionar fronha 2"
    const btnAdd = document.getElementById('btnAddPillowSlot');
    if (btnAdd) {
      btnAdd.addEventListener('click', () => {
        bundleState.pillowcaseCurrentSlot = 1;
        renderPillowcaseArea(container);
      });
    }

    // Carrega produtos de fronha (fronha-mista usa tag diferente por slot)
    const tagsToLoad = bundleState.pillowcaseType === 'fronha-mista'
      ? (selected[0]?.fronhaPrefix === 'fronha-bebe' ? ['fronha-50x70'] : ['fronha-30x40'])
      : rules.tags;
    loadPillowProducts(tagsToLoad, document.getElementById('pillowProductGrid'));
  }

  // Remove uma fronha de um slot
  function removePillowSlot(slotIndex) {
    // Para fronha-mista, remover qualquer slot reseta tudo e volta ao picker
    if (bundleState.pillowcaseType === 'fronha-mista') {
      bundleState.selectedProducts['pillowcase'] = [];
      bundleState.pillowcaseType = null;
    } else {
      const selected = bundleState.selectedProducts['pillowcase'] || [];
      selected.splice(slotIndex, 1);
      bundleState.selectedProducts['pillowcase'] = selected;
    }
    updateCategoryCounts();
    updateSummary();
    updateBedPreview();
    renderPillowcaseArea(document.getElementById('productGrid'));
  }

  // Carrega produtos de fronha filtrando por product_type
  // tags: ['fronha-30x40'] | ['fronha-50x70'] — usados como identificador interno
  const FRONHA_PRODUCT_TYPE = {
    'fronha-30x40': 'Fronha 30 x 40',
    'fronha-50x70': 'Fronha 50 x 70'
  };

  function loadPillowProducts(tags, container) {
    if (!container) return;
    container.innerHTML = '<p class="loading">Carregando...</p>';

    fetch('/collections/fronhas/products.json?limit=250')
      .then(response => response.json())
      .then(data => {
        // Determina os product_types alvo a partir dos identificadores internos
        const targetTypes = tags
          .map(tag => FRONHA_PRODUCT_TYPE[tag.toLowerCase()])
          .filter(Boolean);

        const allProducts = data.products.filter(p => {
          const tags = Array.isArray(p.tags) ? p.tags : (p.tags || '').split(',').map(t => t.trim());
          return !tags.some(t => t.toLowerCase() === 'block');
        });

        const products = targetTypes.length > 0
          ? allProducts.filter(p => targetTypes.includes(p.product_type))
          : allProducts;

        if (products.length === 0) {
          container.innerHTML = `<p>Nenhuma fronha encontrada.</p>`;
          return;
        }

        const imageCategory = tags.includes('fronha-30x40') ? 'pillowcase_bebe' : 'pillowcase_padrao';
        renderProducts(container, products, 'pillowcase', imageCategory);
      })
      .catch((error) => {
        console.error('Erro ao carregar fronhas:', error);
        container.innerHTML = '<p>Erro ao carregar fronhas.</p>';
      });
  }

  // Renderiza produtos
  function renderProducts(container, products, category, imageCategory) {
    if (!products || products.length === 0) {
      container.innerHTML = '<p>Nenhum produto encontrado nesta categoria.</p>';
      return;
    }

    // Para categorias que precisam de tamanho, filtra variantes pelo tamanho da cama
    // Verifica no CATEGORY_CONFIG se a categoria precisa de filtro de tamanho
    const config = CATEGORY_CONFIG[category];
    const needsSize = config && config.needsSize === true;
    const bedSize = bundleState.bedSize;
    const sizeMapping = window.BUNDLE_CONFIG.sizeMapping[bedSize];

    console.log('Renderizando produtos:', {
      category,
      config,
      'config.needsSize': config ? config.needsSize : 'sem config',
      needsSize,
      bedSize,
      sizeMapping,
      totalProducts: products.length
    });

    // Agrupa produtos por cor
    const colorGroups = {};

    products.forEach(product => {
      product.variants.forEach(variant => {
        // Cor está em option2 quando o produto tem 2 opções (tamanho + cor)
        // Produtos com apenas 1 opção (só cor, sem tamanho) têm a cor em option1
        const color = variant.option2 || (needsSize ? null : variant.option1);
        const variantSize = variant.option1 ? variant.option1.toUpperCase().trim() : ''; // Tamanho está em Option1

        // Se precisa de tamanho, filtra pela opção de tamanho
        // Fronhas não entram nesse filtro (todas são tamanho U)
        if (needsSize && sizeMapping) {
          const sizeMappingUpper = sizeMapping.toUpperCase().trim();

          console.log('Comparando tamanhos:', {
            variantSize,
            sizeMappingUpper,
            produto: product.title,
            cor: color
          });

          // Verifica se a variante tem o tamanho correto
          // Deve ser uma correspondência exata ou conter o tamanho
          if (!variantSize || !matchesSize(variantSize, sizeMappingUpper)) {
            return; // Pula esta variante se não for do tamanho correto
          }
        }

        if (color && variant.available) {
          if (!colorGroups[color]) {
            colorGroups[color] = {
              name: color,
              products: [],
              image: null,
              fallbackImage: null,
              variant: variant // Guarda a variante correspondente
            };
          }

          if (!colorGroups[color].products.find(p => p.id === product.id)) {
            colorGroups[color].products.push(product);

            // Tenta encontrar imagem
            if (!colorGroups[color].image) {
              const colorSlug = color.toLowerCase()
                .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
                .replace(/\s+/g, '-')
                .replace(/[^a-z0-9-]/g, '');

              const filesPath = window.BUNDLE_CONFIG?.colorThumbnails?.filesPath || '';
              colorGroups[color].image = cdnFile(`${filesPath}${colorSlug}.png`);

              const variantWithImage = product.variants.find(v => v.option2 === color && v.featured_image);
              if (variantWithImage && variantWithImage.featured_image) {
                colorGroups[color].fallbackImage = variantWithImage.featured_image.src;
              } else if (product.images && product.images.length > 0) {
                colorGroups[color].fallbackImage = product.images[0];
              }
            }
          }
        }
      });
    });

    console.log('Cores encontradas após filtro de tamanho:', Object.keys(colorGroups).length);

    // Se não encontrou nenhuma cor, oculta a aba e avança para a próxima
    if (Object.keys(colorGroups).length === 0) {
      const emptyBtn = document.querySelector(`.category-btn[data-category="${category}"]`);
      if (emptyBtn) {
        emptyBtn.style.display = 'none';
        // Se era a aba ativa, avança para a próxima visível
        if (emptyBtn.classList.contains('active')) {
          emptyBtn.classList.remove('active');
          const nextVisible = document.querySelector('.category-btn:not([style*="display: none"])');
          if (nextVisible) nextVisible.click();
        }
      }
      return;
    }

    // Renderiza cards de cor
    container.innerHTML = Object.values(colorGroups).map(colorGroup => {
      const firstProduct = colorGroup.products[0];

      // Pega a variante correta (pelo tamanho e cor)
      let variant = colorGroup.variant;

      if (!variant && needsSize && sizeMapping) {
        variant = firstProduct.variants.find(v =>
          v.option2 === colorGroup.name &&
          v.option1 && matchesSize(v.option1, sizeMapping)
        );
      }

      if (!variant) {
        variant = firstProduct.variants.find(v => v.option2 === colorGroup.name);
      }

      if (!variant) {
        variant = firstProduct.variants[0];
      }

      const fallbackImage = colorGroup.fallbackImage || 'https://via.placeholder.com/200';

      // Verifica se já está selecionado
      const isSelected = isColorSelected(category, colorGroup.name);

      // Dados serializados no card para uso no clique
      const colorDataJson = JSON.stringify({
        color: colorGroup.name,
        products: colorGroup.products.map(p => ({
          id: p.id,
          title: p.title,
          variants: p.variants,
          image: p.images[0]
        }))
      }).replace(/'/g, '&#39;');

      return `
        <div class="color-card ${isSelected ? 'selected' : ''}"
             data-category="${category}"
             data-color-data='${colorDataJson}'>
          <span class="color-name-tooltip">${colorGroup.name}</span>
          <div class="color-image">
            <img src="${colorGroup.image}"
                 alt="${colorGroup.name}"
                 loading="lazy"
                 onerror="this.src='${fallbackImage}'"
                 width="200"
                 height="200">
          </div>
        </div>
      `;
    }).join('');

    // Clique no card inteiro seleciona o produto
    container.querySelectorAll('.color-card').forEach(card => {
      card.addEventListener('click', handleProductSelect);
    });
  }

  // Verifica se uma cor já está selecionada
  function isColorSelected(category, color) {
    const selected = bundleState.selectedProducts[category];
    if (!selected || selected.length === 0) return false;
    return selected.some(p => p.color === color);
  }

  // Manipula seleção de produto (clique no card inteiro)
  function handleProductSelect(e) {
    const btn = e.currentTarget;
    const category = btn.dataset.category;
    const colorData = JSON.parse(btn.dataset.colorData.replace(/&#39;/g, "'"));

    // Para fronhas, precisa respeitar a quantidade selecionada
    if (category === 'pillowcase') {
      handlePillowcaseSelect(colorData);
    } else {
      handleOtherProductSelect(category, colorData);
    }

    updateCategoryCounts();
    updateSummary();
    updateBedPreview();

    // Mobile: fecha o acordeão ao selecionar estampa (exceto fronhas)
    if (window.innerWidth <= 1024 && category !== 'pillowcase') {
      const productsArea = document.getElementById('productsArea');
      document.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));
      if (productsArea) productsArea.style.display = 'none';
    }
  }

  // Manipula seleção de fronha (nova lógica de slots)
  function handlePillowcaseSelect(colorData) {
    if (!bundleState.selectedProducts['pillowcase']) {
      bundleState.selectedProducts['pillowcase'] = [];
    }

    const selected = bundleState.selectedProducts['pillowcase'];
    const rules = PILLOW_RULES[bundleState.bedSize];
    // fronha-mista no berço permite 2 slots mesmo com maxSlots=1 no PILLOW_RULES
    const maxSlots = bundleState.pillowcaseType === 'fronha-mista' ? 2 : (rules ? rules.maxSlots : 1);

    // Se já atingiu o máximo, não adiciona
    if (selected.length >= maxSlots) return;

    const firstProduct = colorData.products[0];
    const variant = firstProduct.variants.find(v => v.option2 === colorData.color && v.available)
                 || firstProduct.variants.find(v => v.available)
                 || firstProduct.variants[0];

    if (variant) {
      // Preço vem como número decimal (ex: 74.96)
      const price = parseFloat(variant.price) || 0;

      // Determina o prefixo de imagem do preview por produto (necessário para fronha-mista)
      let fronhaPrefix = null;
      if (bundleState.bedSize === 'berco') {
        const pt = bundleState.pillowcaseType;
        if (pt === 'fronha-mista') {
          // Slot 1 é sempre o oposto do slot 0
          fronhaPrefix = selected[0]?.fronhaPrefix === 'fronha-bebe' ? 'fronha-padrao' : 'fronha-bebe';
        } else {
          fronhaPrefix = pt === 'fronha-30x40' ? 'fronha-bebe' : 'fronha-padrao';
        }
      }

      selected.push({
        id: firstProduct.id,
        title: firstProduct.title,
        variantId: variant.id,
        price: price,
        image: firstProduct.image,
        type: 'pillowcase',
        color: colorData.color,
        fronhaPrefix: fronhaPrefix
      });
    }

    // Recarrega a área de fronhas para atualizar slots
    renderPillowcaseArea(document.getElementById('productGrid'));
  }

  // Manipula seleção de outros produtos
  function handleOtherProductSelect(category, colorData) {
    const product = colorData.products[0];
    const config = CATEGORY_CONFIG[category];
    const variant = config && config.needsSize === false
      ? findVariantWithoutBedSize(product.variants, colorData.color, config.variantSize)
      : findVariantBySizeAndColor(product.variants, bundleState.bedSize, colorData.color);

    if (!variant) {
      alert('Variante não disponível para este tamanho');
      return;
    }

    // Se já está selecionado, remove
    if (bundleState.selectedProducts[category] && bundleState.selectedProducts[category].length > 0) {
      const existing = bundleState.selectedProducts[category][0];
      if (existing.color === colorData.color) {
        bundleState.selectedProducts[category] = [];
        loadCategoryProducts(category);
        return;
      }
    }

    // Preço vem como número decimal (ex: 74.96)
    const price = parseFloat(variant.price) || 0;

    bundleState.selectedProducts[category] = [{
      id: product.id,
      title: product.title,
      variantId: variant.id,
      price: price,
      image: product.image,
      type: category,
      color: colorData.color,
      size: bundleState.bedSize
    }];

    // Recarrega produtos para atualizar estado visual
    loadCategoryProducts(category);
  }

  // Encontra variante por tamanho e cor
  function findVariantBySizeAndColor(variants, bedSize, color) {
    if (!isBedSizeAllowed(bedSize)) return null;
    const sizeMapping = window.BUNDLE_CONFIG.sizeMapping[bedSize];
    if (!sizeMapping) return variants[0];

    return variants.find(v =>
      v.option1 && matchesSize(v.option1, sizeMapping) &&
      v.option2 && v.option2.toUpperCase().trim() === color.toUpperCase().trim() &&
      v.available
    ) || null;
  }

  // Categorias como Minhocão só aparecem para Berço, mas sua variante comercial é U.
  // Nesses casos, não usa o tamanho da cama para localizar a variante.
  function findVariantWithoutBedSize(variants, color, variantSize) {
    const normalizedColor = (color || '').toUpperCase().trim();

    return variants.find(v => {
      const colorMatches = v.option2
        ? v.option2.toUpperCase().trim() === normalizedColor
        : v.option1 && v.option1.toUpperCase().trim() === normalizedColor;
      // Sem option2 o produto não tem opção de tamanho (ex.: "U" removido), só estampa.
      const sizeMatches = !variantSize || !v.option2 || (v.option1 && canonicalSize(v.option1) === canonicalSize(variantSize));
      return colorMatches && sizeMatches && v.available;
    }) || variants.find(v => {
      // Tamanho único com a medida no lugar do "U" (ex.: "17 x 260 cm"): acha só pela estampa.
      const colorMatches = v.option2
        ? v.option2.toUpperCase().trim() === normalizedColor
        : v.option1 && v.option1.toUpperCase().trim() === normalizedColor;
      return colorMatches && v.available;
    }) || null;
  }

  // Renderiza checkbox do edredom
  function renderDuvetCheckbox(container) {
    fetch('/collections/capas-de-edredom/products.json')
      .then(response => response.json())
      .then(data => {
        const duvetProduct = data.products.find(p => {
          if (!p.tags) return false;
          const tagsArray = Array.isArray(p.tags) ? p.tags : p.tags.split(',').map(t => t.trim());
          if (tagsArray.some(t => t.toLowerCase() === 'block')) return false;
          return tagsArray.some(t => t.toLowerCase() === 'edredom');
        });

        if (!duvetProduct) {
          container.innerHTML = '<p>Produto edredom não encontrado.</p>';
          return;
        }

        const variant = duvetProduct.variants.find(v =>
          v.option1 && matchesSize(v.option1, window.BUNDLE_CONFIG.sizeMapping[bundleState.bedSize]) &&
          v.available
        );

        if (!variant) {
          const sizeLabel = window.BUNDLE_CONFIG.sizeMapping[bundleState.bedSize] || bundleState.bedSize;
          container.innerHTML = `<p>Edredom indisponível para o tamanho ${sizeLabel}.</p>`;
          return;
        }

        const price = variant ? Math.round(parseFloat(variant.price)).toLocaleString('pt-BR') : '0';
        const isChecked = bundleState.selectedProducts['duvet'] && bundleState.selectedProducts['duvet'].length > 0;

        // Pega a imagem do produto (src direto ou objeto com src)
        let productImage = '';
        if (duvetProduct.images && duvetProduct.images.length > 0) {
          const img = duvetProduct.images[0];
          productImage = typeof img === 'string' ? img : (img.src || '');
        }

        console.log('Duvet product image:', productImage, duvetProduct.images);

        const imgSrc = productImage ? `${productImage.split('?')[0]}?width=300` : null;

        container.innerHTML = `
          <div class="duvet-checkbox-container">
            <label class="duvet-checkbox-label">
              <input type="checkbox" id="duvetCheckbox" class="duvet-checkbox" ${isChecked ? 'checked' : ''}>
              <div class="duvet-option${isChecked ? ' is-checked' : ''}">
                ${imgSrc ? `
                  <div class="duvet-image">
                    <img src="${imgSrc}" alt="${duvetProduct.title}">
                  </div>
                ` : ''}
                <div class="duvet-info">
                  <h4>${duvetProduct.title}</h4>
                  <span class="duvet-price">R$ ${price}</span>
                </div>
                <span class="duvet-toggle-btn${isChecked ? ' is-checked' : ''}">${isChecked ? 'Remover' : 'Adicionar'}</span>
              </div>
            </label>
          </div>
        `;

        // Adiciona event listener
        const checkbox = document.getElementById('duvetCheckbox');
        checkbox.addEventListener('change', function() {
          if (this.checked) {
            // Preço vem como número decimal (ex: 74.96)
            const price = parseFloat(variant.price) || 0;

            bundleState.selectedProducts['duvet'] = [{
              id: duvetProduct.id,
              title: duvetProduct.title,
              variantId: variant.id,
              price: price,
              image: duvetProduct.images[0],
              type: 'duvet',
              size: bundleState.bedSize
            }];
          } else {
            bundleState.selectedProducts['duvet'] = [];
          }
          // Atualiza visual do card
          const option = document.querySelector('.duvet-option');
          const btn = document.querySelector('.duvet-toggle-btn');
          if (option) option.classList.toggle('is-checked', this.checked);
          if (btn) { btn.textContent = this.checked ? 'Remover' : 'Adicionar'; btn.classList.toggle('is-checked', this.checked); }
          updateCategoryCounts();
          updateSummary();
        });
      })
      .catch(error => {
        console.error('Erro ao carregar edredom:', error);
        container.innerHTML = '<p>Erro ao carregar edredom.</p>';
      });
  }

  // Atualiza contadores das categorias
  function updateCategoryCounts() {
    const rules = PILLOW_RULES[bundleState.bedSize];
    const pillowUnitQty = rules ? rules.unitQty : 1;

    Object.keys(CATEGORY_CONFIG).forEach(category => {
      let count = bundleState.selectedProducts[category]?.length || 0;

      // Para fronhas, multiplica pelo unitQty para mostrar o total de unidades
      if (category === 'pillowcase' && count > 0) {
        count = count * pillowUnitQty;
      }

      const countEl = document.getElementById(`count-${category}`);
      if (countEl) {
        countEl.textContent = count;
        countEl.style.display = count > 0 ? 'flex' : 'none';
      }
    });
  }

  // Reseta todos os produtos selecionados (mantém tamanho de cama)
  function handleStartOver() {
    bundleState.selectedProducts = {};
    bundleState.bedSize = null;
    bundleState.pillowcaseType = null;
    bundleState.pillowcaseCurrentSlot = 0;

    // Reseta tabela de medidas
    renderMeasurementsTable(null);

    // Desmarca botões de tamanho
    document.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));

    // Limpa grid de produtos
    const grid = document.getElementById('productGrid');
    if (grid) grid.innerHTML = '';

    // Esconde skip btn
    const skipBtn = document.getElementById('btnSkipStep');
    if (skipBtn) skipBtn.classList.remove('visible');

    updateCategoryCounts();
    updateSummary();
    updateBedPreview();

    // Esconde abas e área de produtos
    const categoryTabs = document.getElementById('categoryTabs');
    const productsArea = document.getElementById('productsArea');
    if (productsArea) productsArea.style.display = 'none';
    if (window.innerWidth <= 1024) {
      if (categoryTabs) categoryTabs.style.display = 'none';
    }

    // Expande seletor de tamanho
    expandSizeSelector();
  }

  // Atualiza resumo
  function updateSummary() {
    const rules = PILLOW_RULES[bundleState.bedSize];
    const pillowUnitQty = rules ? rules.unitQty : 1;

    // Calcula total e monta lista de itens
    let totalPrice = 0;
    let itemCount = 0;
    const allItems = [];

    Object.entries(bundleState.selectedProducts).forEach(([category, products]) => {
      if (!products || products.length === 0) return;
      products.forEach(item => {
        const qty = category === 'pillowcase' ? pillowUnitQty : 1;
        const linePrice = item.price * qty;
        totalPrice += linePrice;
        itemCount += qty;
        allItems.push({ ...item, qty, linePrice, category });
      });
    });

    // Renderiza lista de itens
    const listEl = document.getElementById('bundleItemsList');
    if (listEl) {
      if (allItems.length === 0) {
        listEl.innerHTML = '<p class="bundle-empty-msg">Nenhum item selecionado ainda.</p>';
      } else {
        listEl.innerHTML = allItems.map(item => {
          const rawSrc = item.image ? (item.image.src || item.image) : null;
          const imgSrc = rawSrc ? `${rawSrc.split('?')[0]}?width=120` : null;
          const thumb = imgSrc
            ? `<img class="bundle-item-thumb" src="${imgSrc}" alt="${item.title}">`
            : `<div class="bundle-item-thumb" style="background:#f0f0f0;"></div>`;
          const detail = item.size ? `${item.size}${item.qty > 1 ? ` · ${item.qty} un` : ''}` : (item.qty > 1 ? `${item.qty} un` : '');
          const price = `R$ ${Math.round(item.linePrice).toLocaleString('pt-BR')}`;
          return `
            <div class="bundle-item-row" data-category="${item.category}" data-variant="${item.variantId}">
              ${thumb}
              <div class="bundle-item-info">
                <p class="bundle-item-name">${item.title}</p>
                ${detail ? `<p class="bundle-item-detail">${detail}</p>` : ''}
              </div>
              <span class="bundle-item-price">${price}</span>
              <button class="bundle-item-remove" data-category="${item.category}" data-variant="${item.variantId}" title="Remover">×</button>
            </div>`;
        }).join('');

        // Listeners dos botões de remover
        listEl.querySelectorAll('.bundle-item-remove').forEach(btn => {
          btn.addEventListener('click', function() {
            const cat = this.dataset.category;
            const variantId = this.dataset.variant;
            if (bundleState.selectedProducts[cat]) {
              bundleState.selectedProducts[cat] = bundleState.selectedProducts[cat]
                .filter(p => String(p.variantId) !== String(variantId));
              if (bundleState.selectedProducts[cat].length === 0) {
                delete bundleState.selectedProducts[cat];
              }
            }
            updateCategoryCounts();
            updateBedPreview();
            updateSummary();
          });
        });
      }
    }

    // Atualiza preço total
    const finalPriceEl = document.getElementById('finalPrice');
    if (finalPriceEl) finalPriceEl.textContent = `R$ ${Math.round(totalPrice).toLocaleString('pt-BR')}`;

    // Botão Recomeçar
    const startOverContainer = document.getElementById('startOverContainer');
    if (startOverContainer) {
      startOverContainer.style.display = itemCount > 0 ? 'block' : 'none';
    }

    // Habilita/desabilita botão
    const addBtn = document.getElementById('addBundleBtn');
    if (addBtn) {
      addBtn.disabled = itemCount === 0;
    }
  }

  // Adiciona bundle ao carrinho
  function handleAddToCart() {
    if (!isBedSizeAllowed(bundleState.bedSize)) {
      alert('Selecione um tamanho de cama disponível nesta página.');
      return;
    }
    const items = Object.values(bundleState.selectedProducts).flat();

    if (items.length === 0) {
      alert('Selecione ao menos um produto.');
      return;
    }

    const addBtn = document.getElementById('addBundleBtn');
    addBtn.disabled = true;
    addBtn.textContent = 'Adicionando...';

    const rules = PILLOW_RULES[bundleState.bedSize];
    const pillowUnitQty = rules ? rules.unitQty : 1;

    // Prepara itens para adicionar com propriedades customizadas
    const cartItems = items.map(item => {
      // Para fronhas, multiplica a quantidade pelo unitQty
      const quantity = item.type === 'pillowcase' ? pillowUnitQty : 1;

      return {
        id: item.variantId,
        quantity: quantity,
        properties: {
          '_bundle': 'bed_builder',
          '_bundle_size': bundleState.bedSize || '',
          '_item_type': item.type || ''
        }
      };
    });

    // Adiciona ao carrinho via API
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items: cartItems })
    })
    .then(response => response.json())
    .then(data => {
      // Marca o carrinho com atributo de origem (aparece no pedido como note attribute)
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { '_source': 'bed-builder' } })
      });

      // Eventos de conversão
      fireConversionEvents(items, cartItems);

      // Feedback inline — sem redirecionar
      addBtn.textContent = 'Kit adicionado!';
      addBtn.style.background = '#7fb79a';
      addBtn.style.borderColor = '#7fb79a';

      // Atualiza contador do header
      fetch('/cart.js')
        .then(r => r.json())
        .then(cart => {
          document.querySelectorAll('.cart-count-bubble, .cart-count, [data-cart-count]').forEach(el => {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
        });

      // Busca o HTML atualizado do sidebar e só abre depois que o conteúdo estiver pronto
      fetch('/cart?view=ajax_side_cart')
        .then(r => r.text())
        .then(html => {
          const wrapper = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
          if (wrapper) wrapper.innerHTML = html;
          document.body.classList.add('cart-sidebar-show');
        })
        .catch(() => {
          // Se falhar o fetch do sidebar, abre mesmo assim
          document.body.classList.add('cart-sidebar-show');
        });

      // Restaura botão após 3s
      setTimeout(() => {
        addBtn.disabled = false;
        addBtn.textContent = 'Adicionar Kit ao Carrinho';
        addBtn.style.background = '';
        addBtn.style.borderColor = '';
      }, 3000);
    })
    .catch(error => {
      console.error('Erro ao adicionar ao carrinho:', error);
      alert('Erro ao adicionar produtos ao carrinho. Tente novamente.');
      addBtn.disabled = false;
      addBtn.textContent = 'Adicionar Kit ao Carrinho';
    });
  }

  // Dispara eventos de conversão para Meta Pixel e Google Ads / GA4
  function fireConversionEvents(items, cartItems) {
    const rules = PILLOW_RULES[bundleState.bedSize];
    const pillowUnitQty = rules ? rules.unitQty : 1;

    // Calcula valor total
    let totalValue = 0;
    items.forEach(function(item) {
      const qty = item.type === 'pillowcase' ? pillowUnitQty : 1;
      totalValue += (item.price || 0) * qty;
    });
    const valueInReal = totalValue / 100; // preços em centavos na API

    const contentIds = cartItems.map(function(i) { return String(i.id); });
    const numItems = cartItems.reduce(function(sum, i) { return sum + i.quantity; }, 0);

    // Meta Pixel (fbq)
    if (typeof fbq === 'function') {
      fbq('track', 'AddToCart', {
        content_ids: contentIds,
        content_type: 'product',
        value: valueInReal,
        currency: 'BRL',
        num_items: numItems,
        content_name: 'Kit de Cama MOOUI - ' + (bundleState.bedSize || '')
      });
    }

    // Google Analytics 4 / Google Ads (gtag)
    if (typeof gtag === 'function') {
      var gaItems = items.map(function(item) {
        return {
          item_id: String(item.variantId),
          item_name: item.title || '',
          item_category: item.type || '',
          price: (item.price || 0) / 100,
          quantity: item.type === 'pillowcase' ? pillowUnitQty : 1
        };
      });
      gtag('event', 'add_to_cart', {
        currency: 'BRL',
        value: valueInReal,
        items: gaItems
      });
    }

    // Shopify Analytics (analytics.publish)
    if (window.Shopify && window.Shopify.analytics) {
      window.Shopify.analytics.publish('cart_updated', {
        cart: { item_count: numItems }
      });
    }
  }

  // Atualiza o preview visual da cama
  function updateBedPreview() {
    // Verifica se há algum produto selecionado
    const hasAnyProduct = Object.values(bundleState.selectedProducts).some(
      products => products && products.length > 0
    );

    // Oculta/mostra a imagem base da cama
    const bedBaseImage = document.getElementById('bedBaseImage');
    if (bedBaseImage) {
      bedBaseImage.style.display = hasAnyProduct ? 'none' : 'block';
    }

    // Atualiza lençol de elástico (fitted sheet)
    updatePreviewLayer('fitted_sheet', 'fittedSheetLayer', '.fitted-sheet-preview');

    // Lençol default bege para tamanhos grandes sem lençol de elástico selecionado
    updateDefaultFittedSheet(hasAnyProduct);

    // Atualiza lençol de cima (top sheet)
    updatePreviewLayer('top_sheet', 'topSheetLayer', '.top-sheet-preview');

    // Atualiza capa de edredom (duvet cover)
    updatePreviewLayer('duvet_cover', 'duvetCoverLayer', '.duvet-cover-preview');

    // Atualiza colcha
    updatePreviewLayer('colcha', 'colchaLayer', '.colcha-preview');

    // Atualiza fronhas (pillowcases)
    updatePillowcasesPreview();

    // Atualiza minhocão (protetor de berço)
    updateMinhocaoPreview();
  }

  // Retorna a imagem da camada baseada na categoria + cor selecionada
  function getLayerImage(category, color) {
    if (!color) return null;

    const categoryPrefix = {
      fitted_sheet: 'lencol-elastico',
      top_sheet: 'lencol-cobrir',
      duvet_cover: 'capa-edredom',
      colcha: 'colcha'
    };

    const prefix = categoryPrefix[category];
    if (!prefix) return null;

    const colorSlug = color.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

    const filesPath = window.BUNDLE_CONFIG?.colorThumbnails?.filesPath || '';
    return cdnFile(`${filesPath}${prefix}_${colorSlug}.png`);
  }

  // Retorna o prefixo de fronha baseado no tipo selecionado
  function getFronhaPrefix() {
    return bundleState.pillowcaseType === 'fronha-30x40' ? 'fronha-bebe' : 'fronha-padrao';
  }

  // Atualiza uma camada individual do preview
  function updatePreviewLayer(category, layerId, previewSelector) {
    const layer = document.getElementById(layerId);
    if (!layer) return;

    const selected = bundleState.selectedProducts[category];

    if (selected && selected.length > 0) {
      layer.style.display = 'block';
      const preview = layer.querySelector(previewSelector);
      if (preview) {
        const product = selected[0];

        // Usa imagem PNG da camada baseada na cor selecionada
        const layerImageSrc = getLayerImage(category, product.color);

        // Limpa conteúdo anterior
        preview.innerHTML = '';

        if (!layerImageSrc) return;

        // Cria tag <img> com a imagem da camada em tamanho original
        const img = document.createElement('img');
        img.src = layerImageSrc;
        img.alt = category;
        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.display = 'block';
        img.style.margin = '0 auto';
        img.style.pointerEvents = 'none';
        preview.appendChild(img);
      }
    } else {
      layer.style.display = 'none';
    }
  }

  // Lençol default bege quando não há lençol de elástico selecionado
  // Carrega uma imagem real de lençol para copiar dimensões, depois gera versão bege
  var defaultSheetDataURI = null;
  var defaultSheetReady = false;

  function buildDefaultSheet() {
    // Dimensões reais das imagens de lençol de elástico: 1200x1662
    const c = document.createElement('canvas');
    c.width = 1200;
    c.height = 1662;
    const ctx = c.getContext('2d');
    ctx.fillStyle = '#f6f4e4';
    ctx.fillRect(0, 0, 1200, 1662);
    defaultSheetDataURI = c.toDataURL('image/png');
    defaultSheetReady = true;
  }
  buildDefaultSheet();

  function updateDefaultFittedSheet(hasAnyProduct) {
    const layer = document.getElementById('fittedSheetLayer');
    if (!layer) return;

    const hasFittedSheet = bundleState.selectedProducts.fitted_sheet &&
      bundleState.selectedProducts.fitted_sheet.length > 0;
    const needsDefault = !hasFittedSheet && hasAnyProduct && bundleState.bedSize;

    if (needsDefault && defaultSheetReady) {
      layer.style.display = 'block';
      const preview = layer.querySelector('.fitted-sheet-preview');
      if (preview && !preview.querySelector('.default-fitted-sheet')) {
        preview.innerHTML = '';
        const img = document.createElement('img');
        img.className = 'default-fitted-sheet';
        img.src = defaultSheetDataURI;
        img.alt = '';
        img.style.maxWidth = '100%';
        img.style.maxHeight = '100%';
        img.style.width = 'auto';
        img.style.height = 'auto';
        img.style.display = 'block';
        img.style.margin = '0 auto';
        img.style.pointerEvents = 'none';
        preview.appendChild(img);
      }
    } else {
      const preview = layer.querySelector('.fitted-sheet-preview');
      const defaultImg = preview && preview.querySelector('.default-fitted-sheet');
      if (defaultImg) defaultImg.remove();
      if (!hasFittedSheet) layer.style.display = 'none';
    }
  }

  // Retorna a largura renderizada da BASE.png como unidade de referência
  // Largura real renderizada do lençol/layer (para dimensionar fronhas)
  // Usa o lençol como referência pois ele escala perfeitamente em qualquer tela
  function getRenderedBaseWidth() {
    // 1. Tentar pegar largura de um lençol renderizado (melhor referência)
    const sheetImg = document.querySelector('.fitted-sheet-preview img, .top-sheet-preview img, .duvet-cover-preview img');
    if (sheetImg && sheetImg.clientWidth > 0) return sheetImg.clientWidth;
    if (sheetImg) {
      const rect = sheetImg.getBoundingClientRect();
      if (rect.width > 0) return Math.round(rect.width);
    }
    // 2. Fallback: BASE.png (só quando visível)
    const baseImg = document.getElementById('bedBaseImage');
    if (baseImg && baseImg.clientWidth > 0) return baseImg.clientWidth;
    if (baseImg) {
      const rect = baseImg.getBoundingClientRect();
      if (rect.width > 0) return Math.round(rect.width);
    }
    // 3. Fallback determinístico: largura que a imagem da cama (retrato 1200x1662)
    //    ocupa dentro do container respeitando max-width/max-height (letterbox).
    //    NÃO usar a largura cheia do container: quando o lençol (ou o lençol default)
    //    ainda não foi renderizado/medido, isso gerava fronhas gigantes em tamanhos grandes.
    const BED_ASPECT = 1200 / 1662; // largura / altura das imagens da cama
    const illustration = document.getElementById('bedIllustration');
    if (illustration) {
      const contW = illustration.clientWidth;
      const contH = illustration.clientHeight;
      if (contW > 0 && contH > 0) return Math.round(Math.min(contW, contH * BED_ASPECT));
      if (contW > 0) return contW;
    }
    return 600;
  }

  function getBaseWidth() {
    const baseImg = document.getElementById('bedBaseImage');
    if (baseImg && baseImg.clientWidth > 0) return baseImg.clientWidth;
    const illustration = document.getElementById('bedIllustration');
    if (illustration && illustration.clientWidth > 0) return illustration.clientWidth;
    if (window.innerWidth <= 1024) return window.innerWidth;
    return 600;
  }

  // Escala um valor de referência (calibrado para base de 600px) proporcionalmente
  // Mobile recebe boost de 1.6x para compensar a proporção visual menor
  function scaled(refValue) {
    const base = getBaseWidth();
    const isMobile = window.innerWidth <= 1024;
    const factor = isMobile ? 1.6 : 1;
    return Math.round(refValue * base / 600 * factor);
  }

  // Atualiza fronhas no preview
  function updatePillowcasesPreview() {
    const layer = document.getElementById('pillowcaseLayer');
    const container = document.getElementById('pillowcaseContainer');

    if (!layer || !container) return;

    const selected = bundleState.selectedProducts['pillowcase'];

    if (selected && selected.length > 0) {
      layer.style.display = 'block';
      container.innerHTML = '';
      container.classList.toggle('pillowcase-container-berco', bundleState.bedSize === 'berco');

      const filesPath = window.BUNDLE_CONFIG?.colorThumbnails?.filesPath || '';

      container.style.left = '50%';

      // ── Fronha-mista (berço "1 de cada"): posicionamento absoluto ──
      if (bundleState.pillowcaseType === 'fronha-mista' && selected.length === 2) {
        const baseW = getRenderedBaseWidth();
        const pMaxW = Math.round(baseW * 0.77);
        const bMaxW = Math.round(baseW * 0.46);
        const pMaxH = Math.round(pMaxW * 0.72);
        const bebeTop = Math.round(pMaxH * 0.25);
        const cW = pMaxW;
        const cH = bebeTop + Math.round(bMaxW * 0.72);

        container.style.width    = cW + 'px';
        container.style.height   = cH + 'px';
        container.style.position = 'relative';

        const padraoProduct = selected.find(p => p.fronhaPrefix === 'fronha-padrao');
        const bebeProduct   = selected.find(p => p.fronhaPrefix === 'fronha-bebe');
        const slots = [
          { product: padraoProduct, prefix: 'fronha-padrao', left: 0, top: 0, zIndex: 1, maxW: pMaxW },
          { product: bebeProduct, prefix: 'fronha-bebe', left: Math.round((cW - bMaxW) / 2), top: bebeTop, zIndex: 2, maxW: bMaxW }
        ];

        slots.forEach(({ product, prefix, left, top, zIndex, maxW }) => {
          const slug = (product.color || '').toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
          const div = document.createElement('div');
          div.style.cssText = `position:absolute; left:${left}px; top:${top}px; z-index:${zIndex};`;
          const img = document.createElement('img');
          img.src = cdnFile(`${filesPath}${prefix}_${slug}.png`);
          img.alt = product.color;
          img.style.cssText = `display:block; max-width:${maxW}px; height:auto; pointer-events:none;`;
          div.appendChild(img);
          container.appendChild(div);
        });
        return;
      }
      // ── Fim fronha-mista ──

      const rules = PILLOW_RULES[bundleState.bedSize];
      const unitQty = rules ? rules.unitQty : 1;

      let globalPillowIndex = 0;
      const totalPillows = selected.length * unitQty;

      const previewList = (bundleState.pillowcaseType === 'fronha-mista' && selected.length === 2)
        ? [selected[1], selected[0]]
        : selected;

      // Tamanho da fronha como % da largura da BASE.png renderizada
      const baseW = getRenderedBaseWidth();

      const SIZE_PCT = {
        berco: 0.77, mini_cama: 0.77, solteiro: 0.77,
        solteiro_king: 0.73,
        casal: 0.50, queen: 0.50, king: 0.50
      };
      const SIZE_BEBE_PCT = { berco: 0.44, default: 0.28 };

      previewList.forEach((product, slotIndex) => {
        const fronhaPrefix = product.fronhaPrefix || getFronhaPrefix();

        for (let i = 0; i < unitQty; i++) {
          const pillowDiv = document.createElement('div');
          pillowDiv.className = 'pillowcase-preview';

          const largerBeds = ['casal', 'queen', 'king'];
          const isLargerBed = largerBeds.includes(bundleState.bedSize);
          const isBebe = fronhaPrefix === 'fronha-bebe';
          const isBigPillow = ['berco', 'mini_cama', 'solteiro', 'solteiro_king'].includes(bundleState.bedSize);
          const isSKing = bundleState.bedSize === 'solteiro_king';

          let pillowW;
          if (isBebe) {
            const pct = bundleState.bedSize === 'berco' ? SIZE_BEBE_PCT.berco : SIZE_BEBE_PCT.default;
            pillowW = Math.round(baseW * pct);
          } else {
            pillowW = Math.round(baseW * (SIZE_PCT[bundleState.bedSize] || 0.37));
          }

          pillowDiv.style.width = pillowW + 'px';
          pillowDiv.style.maxWidth = pillowW + 'px';

          pillowDiv.setAttribute('data-pillow-index', i);
          pillowDiv.setAttribute('data-slot-index', slotIndex);

          const positionIndex = unitQty > 1 ? i : globalPillowIndex;

          if (positionIndex === 0) {
            pillowDiv.classList.add('pillow-left');
          } else {
            pillowDiv.classList.add('pillow-right');
          }

          // Posicionamento — percentual da BASE.png renderizada
          const bpx = (ref) => Math.round(ref * baseW / 600);

          if (bundleState.pillowcaseType === 'fronha-mista' && totalPillows >= 2) {
            pillowDiv.style.zIndex = positionIndex === 0 ? '1' : '2';
            if (positionIndex === 0) {
              pillowDiv.style.transform = 'none';
            } else {
              pillowDiv.style.marginLeft = bpx(-63) + 'px';
              pillowDiv.style.transform = `translateY(${bpx(-15)}px)`;
            }
          } else if (totalPillows >= 2 && !isLargerBed) {
            if (positionIndex === 0) {
              const tx = isSKing ? bpx(-10) : isBigPillow ? bpx(10) : bpx(-7);
              pillowDiv.style.transform = `translateX(${tx}px) translateY(0px)`;
            } else {
              const ml = isBigPillow ? bpx(-300) : isSKing ? bpx(-157) : bpx(-112);
              pillowDiv.style.marginLeft = ml + 'px';
              const ty = isBigPillow ? bpx(48) : isSKing ? bpx(25) : bpx(20);
              pillowDiv.style.transform = `translateX(0px) translateY(${ty}px)`;
            }
          } else if (isLargerBed && totalPillows >= 2) {
            const kitOffsetY = slotIndex === 0 ? 0 : bpx(-120);
            pillowDiv.style.zIndex = slotIndex === 0 ? '1' : '2';
            const rot = positionIndex === 0 ? 'rotate(3deg)' : 'rotate(-3deg)';
            if (positionIndex === 0) {
              pillowDiv.style.transform = `translateX(${bpx(-7)}px) translateY(${kitOffsetY}px) ${rot}`;
            } else {
              pillowDiv.style.marginLeft = bpx(-35) + 'px';
              pillowDiv.style.transform = `translateX(${bpx(7)}px) translateY(${kitOffsetY}px) ${rot}`;
            }
          }

          globalPillowIndex++;

          const colorSlug = (product.color || '').toLowerCase()
            .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, '-')
            .replace(/[^a-z0-9-]/g, '');
          const img = document.createElement('img');
          img.src = cdnFile(`${filesPath}${fronhaPrefix}_${colorSlug}.png`);
          img.alt = product.color;
          img.style.display = 'block';
          img.style.pointerEvents = 'none';
          img.style.width = pillowW + 'px';
          img.style.maxWidth = pillowW + 'px';
          img.style.height = 'auto';

          pillowDiv.appendChild(img);
          container.appendChild(pillowDiv);
        }
      });

      if (unitQty === 2) {
        container.classList.add('has-two-pillows');
        if (selected.length >= 2) {
          container.style.flexWrap = 'wrap';
          container.style.width = Math.round(baseW * 0.95) + 'px';
          container.style.maxWidth = '';
        } else {
          container.style.flexWrap = 'nowrap';
          container.style.width = '';
          container.style.maxWidth = '100%';
        }
      } else {
        container.classList.remove('has-two-pillows');
        container.style.flexWrap = 'nowrap';
        container.style.width = '';
        container.style.maxWidth = '100%';
        container.style.height = '';
        container.style.position = '';
      }

      setTimeout(() => {
        window.dispatchEvent(new CustomEvent('pillowsUpdated'));
      }, 100);
    } else {
      layer.style.display = 'none';
    }
  }

  // Atualiza minhocão no preview (protetor de berço)
  function updateMinhocaoPreview() {
    const layer = document.getElementById('minhocaoLayer');

    if (!layer) return;

    const selected = bundleState.selectedProducts['minhocao'];

    // Mostra minhocão apenas se for tamanho berço E tiver produto selecionado
    if (bundleState.bedSize === 'berco' && selected && selected.length > 0) {
      layer.style.display = 'block';

      const product = selected[0];
      const colorSlug = (product.color || '').toLowerCase()
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/\s+/g, '-')
        .replace(/[^a-z0-9-]/g, '');

      const filesPath = window.BUNDLE_CONFIG?.colorThumbnails?.filesPath || '';
      const preview = layer.querySelector('.minhocao-preview');
      if (preview && colorSlug) {
        const img = preview.querySelector('img');
        if (img) img.src = cdnFile(`${filesPath}minhocao_${colorSlug}.png`);
      }
    } else {
      layer.style.display = 'none';
    }
  }

  // Obtém URL da imagem PNG do produto por categoria
  function getProductImage(colorName, category) {
    const colorSlug = colorName.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

    const filesPath = window.BUNDLE_CONFIG?.colorThumbnails?.filesPath || '';

    // Mapeia categoria para sufixo do arquivo
    const categoryMap = {
      'pillowcase': 'fronha',
      'top_sheet': 'lencol-cima',
      'fitted_sheet': 'lencol-elastico',
      'duvet_cover': 'capa-edredom',
      'duvet': 'edredom'
    };

    const suffix = categoryMap[category] || 'fronha';
    return cdnFile(`${filesPath}${colorSlug}-${suffix}.png`);
  }

  // Mantém função antiga para compatibilidade com miniaturas circulares
  function getColorThumbnail(colorName) {
    const colorSlug = colorName.toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

    const filesPath = window.BUNDLE_CONFIG?.colorThumbnails?.filesPath || '';
    return cdnFile(`${filesPath}${colorSlug}.png`);
  }

  // Removido painel de controle
  function initPillowControls() {
    // Função removida - não é mais necessária
    return;
    const controls = {
      marginLeft: document.getElementById('pillowMarginLeft'),
      translateY: document.getElementById('pillowTranslateY'),
      translateX: document.getElementById('pillowTranslateX'),
      rotate: document.getElementById('pillowRotate'),
      marginTop: document.getElementById('pillowMarginTop'),
      size: document.getElementById('pillowSize')
    };

    const values = {
      marginLeftValue: document.getElementById('pillowMarginLeftValue'),
      translateYValue: document.getElementById('pillowTranslateYValue'),
      translateXValue: document.getElementById('pillowTranslateXValue'),
      rotateValue: document.getElementById('pillowRotateValue'),
      marginTopValue: document.getElementById('pillowMarginTopValue'),
      sizeValue: document.getElementById('pillowSizeValue')
    };

    const btnCopy = document.getElementById('btnCopyValues');

    function updateStyles() {
      const marginLeft = controls.marginLeft.value;
      const translateY = controls.translateY.value;
      const translateX = controls.translateX.value;
      const rotate = controls.rotate.value;
      const marginTop = controls.marginTop.value;
      const size = controls.size.value;

      // Atualiza valores exibidos
      values.marginLeftValue.textContent = `${marginLeft}px`;
      values.translateYValue.textContent = `${translateY}px`;
      values.translateXValue.textContent = `${translateX}px`;
      values.rotateValue.textContent = `${rotate}deg`;
      values.marginTopValue.textContent = `${marginTop}px`;
      values.sizeValue.textContent = `${size}px`;

      // Aplica estilos dinamicamente
      const style = document.getElementById('pillowDynamicStyle') || document.createElement('style');
      style.id = 'pillowDynamicStyle';
      style.textContent = `
        .pillowcase-preview:not(:first-child) {
          margin-left: ${marginLeft}px !important;
        }
        .pillowcase-preview.pillowcase-rotated {
          transform: rotate(${rotate}deg) translateY(${translateY}px) translateX(${translateX}px) !important;
        }
        .pillowcase-preview:nth-child(3) {
          margin-top: ${marginTop}px !important;
        }
        .pillowcase-preview img {
          max-width: ${size}px !important;
          max-height: ${size}px !important;
        }
      `;
      if (!document.getElementById('pillowDynamicStyle')) {
        document.head.appendChild(style);
      }
    }

    // Event listeners
    Object.values(controls).forEach(control => {
      if (control) {
        control.addEventListener('input', updateStyles);
      }
    });

    // Aplica estilos iniciais
    updateStyles();

    // Botão copiar
    if (btnCopy) {
      btnCopy.addEventListener('click', () => {
        const cssCode = `
/* Tamanho das fronhas */
.pillowcase-preview img {
  max-width: ${controls.size.value}px;
  max-height: ${controls.size.value}px;
}

/* Layout sobreposto para TODAS as camas */
.pillowcase-preview:not(:first-child) {
  margin-left: ${controls.marginLeft.value}px;
}

/* Rotaciona a segunda fronha de cada jogo */
.pillowcase-preview.pillowcase-rotated {
  transform: rotate(${controls.rotate.value}deg) translateY(${controls.translateY.value}px) translateX(${controls.translateX.value}px) !important;
  position: relative;
}

/* Espaçamento vertical entre jogos */
.pillowcase-preview:nth-child(3) {
  margin-top: ${controls.marginTop.value}px;
}
        `.trim();

        navigator.clipboard.writeText(cssCode).then(() => {
          btnCopy.textContent = '✅ Copiado!';
          setTimeout(() => {
            btnCopy.textContent = '📋 Copiar Valores CSS';
          }, 2000);
        });
      });
    }
  }

  // Inicializa quando DOM estiver pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      initPillowControls();
    });
  } else {
    init();
    initPillowControls();
  }

})();
